import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Route, Switch, Redirect } from 'react-router-dom';
import { OrganizationRouter, RolesRouter, UsersRouter, UsersRouterV1, WebhooksRouter, EmailRouter } from 'components/routing';

import { Template } from 'components/template/Template';
import { EventList, PageError } from 'pages';

import { Loading } from 'components';

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false
        }
    }
});

/**
 * @function account
 * @description Display the instanciation of the DropdownAccount
 * @return {ReactElement} - Component to document
 */
export default function App() {
    return (
        <QueryClientProvider client={queryClient}>
            <React.Suspense fallback={<Loading />}>
                <Switch>
                    <Route
                        exact
                        path="/"
                        render={() => {
                            let url = window.location.pathname + window.location.search;
                            let redirect = url;
                            if (url === '/') {
                                redirect = `${url}organizations`;
                            }
                            if (url === '/target/') {
                                redirect = '/organizations';
                            }
                            return <Redirect to={redirect} />;
                        }}
                    />
                    <Route
                        path="/organizations"
                        render={basenameProps => {
                            return (
                                <Template>
                                    <OrganizationRouter match={basenameProps.match} />
                                </Template>
                            );
                        }}
                    />
                    <Route
                        path="/emails"
                        render={basenameProps => {
                            return (
                                <Template>
                                    <EmailRouter match={basenameProps.match} />
                                </Template>
                            );
                        }}
                    />
                    <Route
                        path="/events"
                        render={basenameProps => {
                            return (
                                <Template>
                                    <EventList />
                                </Template>
                            );
                        }}
                    />
                    <Route //route to delete when v1 takes over
                        path={['/applications/legacy']}
                        render={basenameProps => {
                            return (
                                <Template>
                                    <UsersRouter match={basenameProps.match} />
                                </Template>
                            );
                        }}
                    />
                    <Route
                        path={['/users', '/applications']}
                        render={basenameProps => {
                            const path = basenameProps.match.path;
                            const useCase = path.startsWith('/applications') ? 'applications' : 'users';

                            return (
                                <Template>
                                    <UsersRouterV1 match={basenameProps.match} useCase={useCase} />
                                </Template>
                            );
                        }}
                    />

                    <Route
                        path="/roles"
                        render={basenameProps => {
                            return (
                                <Template>
                                    <RolesRouter match={basenameProps.match} />
                                </Template>
                            );
                        }}
                    />
                    <Route
                        path="/tools"
                        render={basenameProps => {
                            return (
                                <Template>
                                    <WebhooksRouter match={basenameProps.match} />
                                </Template>
                            );
                        }}
                    />
                    <Route
                        render={() => (
                            <Template>
                                <PageError errorCode={404} backHomeUrl={'/organizations'} />
                            </Template>
                        )}
                    />
                </Switch>
            </React.Suspense>
        </QueryClientProvider>
    );
}
